import "../Scss/main.scss";
import { Map } from './map';
import "../node_modules/bootstrap";
import "../node_modules/@popperjs/core";

import "@fortawesome/fontawesome-free/js/all";
import "slick-carousel/slick/slick";


import AOS from "aos/dist/aos";




import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';


jQueryBridget('masonry', Masonry, $);
jQueryBridget( 'imagesLoaded', imagesLoaded, $ );

document.addEventListener("DOMContentLoaded", function() {
    let mapElement = document.getElementById('map');
    
    Map.loadGoogleMapsApi().then(function(googleMaps) {
      Map.createMap(googleMaps, mapElement);
    });
  });
 
$(document).ready(function(){

    AOS.init();

  // $('.slick').slick();








  const $container = $('.grid');
$container.imagesLoaded(() => {
  $container.masonry({
    columnWidth: 20,
    columnHeight: 20,
    itemSelector: '.grid-item',
    
  });
});




$("a").click(function() {
    var target = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(target).offset().top
    }, 600);
  });
  
  
  function rotate() {
      $('#next').click();
  }

});
 
// Initialize and add the map














